import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Flex, Modal, Spin, Tooltip, Typography } from 'antd'
import { useForm } from 'antd/es/form/Form'
import _ from 'lodash'
import React, { useState } from 'react'
import { ContentPartFilter } from '../../../../../components/content-part/ContentPartFilter'
import { PageHeader } from '../../../../../components/page-header'
import { useVeterinaryProductCategory } from './useVeterinaryProductCategory'
import { AddVeterinaryProductCategoryModal } from './AddTypesOfVeterinaryProductCategory'
import { useGetDataOnScroll } from '../../../../../components/getDataOnScrollProps/useGetDataOnScrollProps'
import { useTranslation } from 'react-i18next'
import { useLazyGetVeterinaryProductCategoryListQuery } from '../../../../../redux/api/handBooksApi/veterinary/veterinaryProductionCategoryApi'
import { EntDirectoryInfoName } from '../../../../../models/directoryInfoName'
import { EntTransportCategoryFilter } from '../../../../../models/filters/transportCategoryFilter'
import { FilterByNameHB } from "../../../../../components/filterByNameHB/FilterByNameHB";

enum FormField {
	name,
}

export const VeterinaryProductCategory = () => {
	const [form] = useForm()
	const { t } = useTranslation()
	const [modal, contextHolder] = Modal.useModal()
	const [selectedVeterinaryProductCategory, setSelectedVeterinaryProductCategory] =
		useState<EntDirectoryInfoName>(new EntDirectoryInfoName())
	const [showModal, setShowModal] = useState<boolean>(false)
	const {
		onAddVeterinaryProductCategory,
		onDeleteVeterinaryProductCategory,
		onEditVeterinaryProductCategory,
	} = useVeterinaryProductCategory(modal, () => {
		searchHandleClick()
	})
	const [height, setHeight] = useState<number>(0)

	const [getArchiveFolders] = useLazyGetVeterinaryProductCategoryListQuery()

	const {
		filter,
		fetching,
		data,
		access,
		totalItems,
		setData,
		setFetching,
		setFilter,
		scrollHandler,
		setCurrentPage,
	} = useGetDataOnScroll<EntDirectoryInfoName, EntTransportCategoryFilter>({
		initialFilter: new EntTransportCategoryFilter(),
		query: getArchiveFolders,
	})

	const openAddModal = (item: EntDirectoryInfoName) => {
		setSelectedVeterinaryProductCategory(item)
		setShowModal(true)
	}

	const setEntityFromFields = (): EntTransportCategoryFilter => {
		let filt: EntTransportCategoryFilter = _.clone(filter)
		filt.name = form.getFieldValue(FormField.name) ?? null
		filt.page = 1
		return filt
	}

	const clearFields = () => {
		form.setFields([{ name: FormField.name, value: null }])
	}

	const searchHandleClick = () => {
		setFilter(setEntityFromFields())
		setData([])
		setCurrentPage(0)
		setFetching(true)
	}

	const table = (
		<div style={{ maxHeight: `${height}px`, overflow: 'auto' }} onScroll={scrollHandler}>
			<table>
				<thead>
					<tr>
						<th style={{ width: '40px' }}>#</th>
						<th>{t('general.nameKy')}</th>
						<th>{t('general.nameRu')}</th>
						<th style={{ width: '120px' }}></th>
					</tr>
				</thead>
				<tbody>
					{fetching ? (
						<tr>
							<th colSpan={5}>
								<Spin
									spinning={fetching}
									style={{
										width: '100%',
										height: '180px',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
									}}
								/>
							</th>
						</tr>
					) : (
						<></>
					)}
					{data.map((item, index) => (
						<tr key={item.id}>
							<td>{++index}</td>
							<td>{item?.nameKy}</td>
							<td>{item?.nameRu}</td>
							<td>
								<Flex gap='small'>
									{access && access.methodPut && (
										<Tooltip title={t('general.edit')}>
											<Button
												className='btn_edit'
												onClick={() => {
													openAddModal(item)
												}}
												type='primary'
												shape='circle'
												icon={<EditOutlined />}
											/>
										</Tooltip>
									)}
									{access && access.methodDelete && (
										<Tooltip title={t('general.delete')}>
											<Button
												className='btn_edit'
												danger
												onClick={() => {
													onDeleteVeterinaryProductCategory(item)
												}}
												type='primary'
												shape='circle'
												icon={<DeleteOutlined />}
											/>
										</Tooltip>
									)}
								</Flex>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	)

	return (
		<>
			<PageHeader
				title={t('titles.types_of_products')}
				additionalInfo={
					<Typography.Text style={{ marginBottom: '0.5em', display: 'block' }} type='secondary'>
						{t('general.records_found')} {totalItems}
					</Typography.Text>
				}
			/>
			{access && access.methodPost && (
				<Button
					type='primary'
					icon={<PlusOutlined />}
					onClick={() => {
						openAddModal(new EntDirectoryInfoName())
					}}
				>
					{t('general.add')}
				</Button>
			)}
			<ContentPartFilter
				filter={
					<FilterByNameHB
						onSearch={searchHandleClick}
						onReset={() => {
							clearFields()
							searchHandleClick()
						}}
						formField={FormField}
						form={form}
					/>
				}
				setHeight={setHeight}
				table={table}
			/>
			<AddVeterinaryProductCategoryModal
				veterinaryProductCategory={selectedVeterinaryProductCategory}
				show={showModal}
				onHide={() => {
					setShowModal(false)
				}}
				onSubmit={
					selectedVeterinaryProductCategory.id !== 0
						? onEditVeterinaryProductCategory
						: onAddVeterinaryProductCategory
				}
			/>
			{contextHolder}
		</>
	)
}
